const categoryChoices = [
  {
    value: 1,
    name: "Strength",
    showIntensity: true,
    showDuration: true,
    intensityLabel: "Avg. Heart Rate"
  },
  {
    value: 2,
    name: "Cardio",
    showIntensity: true,
    showDuration: true,
    intensityLabel: "Avg. Heart Rate"
  },
  {
    value: 3,
    name: "Wellness",
    showIntensity: false,
    showDuration: true,
    intensityLabel: ""
  },
  {
    value: 4,
    name: "USP",
    showIntensity: true,
    showDuration: false,
    intensityLabel: "Amount"
  },
];

export default categoryChoices;
